var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgRoundTag = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Ebene 1",
    viewBox: "0 0 96 80",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "b"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 40,
    r: 19,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 60a20 20 0 1 1 20-20 20.06 20.06 0 0 1-20 20Zm0-38a18 18 0 1 0 18 18 18.05 18.05 0 0 0-18-18Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 25.3a3.3 3.3 0 1 0 3.3 3.3 3.33 3.33 0 0 0-3.3-3.3Zm0 5.1a1.8 1.8 0 1 1 1.8-1.8 1.79 1.79 0 0 1-1.8 1.8Z"
  })));
};
export default SvgRoundTag;